import React from 'react'
import styled, {css, useTheme} from 'styled-components'
import NextImage from 'next/image'

import {
  Box,
  Desktop,
  LazyImageProps,
  Mobile,
  StyleProps,
  useWindowSize,
  prefixUrl,
} from '@miro-site/core'

const ImageWrapper = styled(Box)<{
  onClick?: React.MouseEventHandler<HTMLElement>
}>(
  ({theme}) => css`
    border: 1px solid ${theme.colors.grey};
    overflow: hidden;

    img {
      object-fit: cover;
    }
  `,
)

export interface CardImageProps {
  onShowCardDescription: React.MouseEventHandler
  mobileImage?: LazyImageProps
  image: LazyImageProps
  wrapperStyles?: StyleProps
  className?: string
  priority?: boolean
}

const CardImage: React.FC<CardImageProps> = ({
  onShowCardDescription,
  mobileImage,
  image,
  wrapperStyles,
  className,
  priority = false,
}) => {
  const theme = useTheme()

  const windowSize = useWindowSize()

  const isMobileViewPort = windowSize.width && windowSize.width < theme.breakpoints.small

  if (!image.original.webp) {
    return null
  }

  const getImages = () => {
    const placeholder = {
      placeholder: undefined,
      blurDataURL: undefined,
    }

    if (!priority) {
      placeholder.placeholder = 'blur'
      placeholder.blurDataURL = prefixUrl(image.placeholder.webp)
    }

    let desktopImageElement = (
      <NextImage
        layout="fill"
        src={prefixUrl(image.original.webp)}
        unoptimized
        alt={image.name}
        priority={priority}
        {...placeholder}
      />
    )

    if (mobileImage) {
      desktopImageElement = <Desktop>{desktopImageElement}</Desktop>

      if (!priority) {
        placeholder.blurDataURL = prefixUrl(mobileImage.placeholder.webp)
      }

      const mobileImageElement = (
        <Mobile>
          <NextImage
            layout="fill"
            src={prefixUrl(mobileImage.original.webp)}
            unoptimized
            alt={mobileImage.name}
            priority={priority}
            {...placeholder}
          />
        </Mobile>
      )

      return (
        <>
          {desktopImageElement}
          {mobileImageElement}
        </>
      )
    }

    return desktopImageElement
  }

  return (
    <ImageWrapper
      className={className}
      $styles={wrapperStyles}
      onClick={e => {
        if (!isMobileViewPort) {
          return
        }

        onShowCardDescription(e)
      }}
    >
      {getImages()}
    </ImageWrapper>
  )
}

export default CardImage
